import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

export const RightCheck = () => (
  <FontAwesomeIcon
    icon={faCheck}
    style={{
      width: '14px',
      height: '15px',
      marginRight: '8px',
    }}
  />
)

export const isvEmptyStatefeaturesList = [
  {
    feature:
      'Save time by tracking all Channel offers and Contracts via Resellers in one place.',
    icon: <RightCheck />,
  },
  {
    feature:
      'Stay informed with real-time notifications on Reseller authorization and Channel offer activities.',
    icon: <RightCheck />,
  },
  {
    feature:
      'Enhance collaboration and streamline Marketplace operations management by bringing your Resellers into Labra.',
    icon: <RightCheck />,
  },
  {
    feature:
      ' Track progress of Channel offers at every stage to stay in control.',
    icon: <RightCheck />,
  },
]
